import styled from '@emotion/styled';

import NextIcon from '@/assets/icons/icon_next_gray.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { disclosure } from '@/utility/theme/animation';

export const FundWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  }),
);

export const TextWrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
  }),
);

export const Icon = styled.div((props: { isOpen: boolean }) =>
  mq({
    width: '13px',
    height: '15px',
    background: `center / contain no-repeat url(${NextIcon})`,
    marginLeft: defaultTheme.spacing.xs,
    transform: `rotate(${props.isOpen ? '-90' : '90'}deg)`,
    transition: '.2s all ease-in-out',
  }),
);

export const FundSettingContent = styled.div((props: { isOpen: boolean }) =>
  mq({
    display: 'grid',
    gridGap: `${defaultTheme.spacing.l} 0`,
    width: '100%',
    padding: props.isOpen
      ? `${defaultTheme.spacing.xxl} ${defaultTheme.spacing.s}`
      : `0 ${defaultTheme.spacing.s}`,
    ...disclosure(props.isOpen, '300px'),
  }),
);

export const FundSettingWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }),
);

export const SettingName = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
  }),
);

export const Form = styled.form(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
  }),
);

export const HundredYenSpan = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    margin: `0 ${defaultTheme.spacing.l} 0 ${defaultTheme.spacing.xs}`,
  }),
);

export const ValidMsg = styled.p(() =>
  mq({
    color: defaultTheme.text.error,
    fontSize: defaultTheme.font.size.xs,
    textAlign: 'left',
    '&::before': {
      content: '"※"',
    },
  }),
);
